"use client"

import { useEffect, useState, useRef } from "react";

import moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('pt-br');

import "./content.css"

export function headerDated(data = new Date(), hasWeekDate = false) {
  const m = moment(data);
  const diaSemana = m.format('dddd');
  const dia = m.date();
  const mes = m.format('MMMM');
  const ano = m.year();

  const weekDate = hasWeekDate === true ? `${diaSemana.charAt(0).toUpperCase() + diaSemana.slice(1)}, dia ` : '';

  return `${weekDate}${dia} de ${mes.charAt(0).toUpperCase() + mes.slice(1)} de ${ano}`;
}

export function TheContent(content) {
  const [html, setHtml] = useState('');

  useEffect(() => {
    setHtml(content);
  }, []);

  return (
    <div className="content" dangerouslySetInnerHTML={{ __html: html }}></div>
  )
}

export function preContent(content, size = 200) {
  const cleanContent = content.replace(/<[^>]*>/g, '');
  const truncatedContent = cleanContent.slice(0, size);

  const finalContent = cleanContent.length > size
    ? `${truncatedContent} [...]`
    : truncatedContent;

  return finalContent;
}

export function theCat(cats, key = false) {
  if(!cats || cats.length === 0) return 'Sem Categoria';
  const cat = cats[0];
  if(key === false) return cat[0];
  return cat[key];
}

export function useInView(threshold = 0.2) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);

  return { ref, isVisible };
}

export function whatsApp(numbers = []) {
  let whatsapp = '#';
  let endpoint = 'https://api.whatsapp.com/send/?phone=';

  if(numbers && numbers.length > 0) {
    whatsapp = `${endpoint}55${numbers[0].sanitized}`;
  }

  return whatsapp
}

export function brazilFormat(value, format = 'DD/MM/YYYY') {
  return moment(value).format(format)
}

